module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/teRH3/tc-custom/9780374721480.jpg?1737775932548",
      "alt": "This image is the cover for the book The High Road"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The High Road\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Love and tragedy converge in a seaside town in "), _c('i', [_vm._v("The High Road")]), _vm._v(", a newly reissued novel from Edna O’Brien, the author of "), _c('i', [_vm._v("Girl")]), _vm._v(" and “one of the most celebrated writers in the English language” (NPR’s "), _c('i', [_vm._v("Weekend Edition")]), _vm._v(")")]), _c('br'), _c('br'), _vm._v("This richly peopled, compellingly readable novel explores the many lives of women—as mystic, mother, daughter, and lover. There is Iris, with her “winsome wonsome” ways, no longer young; there is Charlotte, a troubled debutante who has fled from society; and there is the narrator, Anna, who feels that her emotional life has folded until she meets a young Spanish girl named Catalina."), _c('br'), _c('br'), _vm._v("Set in a seaside enclave on the Mediterranean coast, "), _c('i', [_vm._v("The High Road")]), _vm._v(" is a passionate account of lost love and the return to loving, where currents of regret and loneliness clash with a fiery instinct for survival.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Edna O'Brien\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Picador\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0